<template>
  <div class="scroll-button" v-show="showScrollButton">
    <button  @click.prevent="scrollToTop">Scroll to Top</button>
    <button @click.prevent="scrollToBottom">Scroll to Bottom</button>
  </div>
</template>

<script>
export default {
  name: "AutoScroll",
  props: {
    scrollableElementId: String // Optional: ID of the scrollable element
  },
  data() {
    return {
      showScrollButton: true
    };
  },
  methods: {
    scrollToTop() {
      debugger
      const scrollableElement = this.getScrollableElement();
      if (scrollableElement) {
        scrollableElement.scrollTop = 0;
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    scrollToBottom() {
      debugger
      const scrollableElement = this.getScrollableElement();
      if (scrollableElement) {
        scrollableElement.scrollTop = scrollableElement.scrollHeight;
      } else {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      }
    },
    getScrollableElement() {
      return this.scrollableElementId ? document.getElementById(this.scrollableElementId) : null;
    },
    handleScroll() {
      const scrollableElement = this.getScrollableElement();
      if (scrollableElement) {
        this.showScrollButton = scrollableElement.scrollTop > 100; // Show the scroll button when scrolled down 100px inside the scrollable element
      } else {
        this.showScrollButton = window.pageYOffset > 100; // Show the scroll button when scrolled down 100px on the main page
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style>
.scroll-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.scroll-button button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 10px;
  cursor: pointer;
  display: block;
  margin-bottom: 5px;
}
</style>
